import styled, { css } from 'styled-components'

import { Cores } from '../../styles/cores'

export const Componente = styled.div<{ opcoesHorizontal?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: ${props => (props.opcoesHorizontal ? 'row' : 'column')};
  ${props =>
    props.opcoesHorizontal &&
    css`
      align-items: center;
      justify-content: space-between;
    `}
  margin-bottom: 25px;
  width: 100%;

  ${props =>
    !props.opcoesHorizontal &&
    css`
      .radio-input {
        margin-bottom: 11px;
      }
    `}

  .radio-input:last-of-type {
    margin: 0px;
  }

  ${({ theme: { ComErro } }) =>
    ComErro &&
    css`
      span {
        opacity: 1;
        bottom: -20px;
      }
    `}
`

export const Erro = styled.span`
  color: ${Cores.PERIGO_ERRO};
  font-size: 10px;
  margin-top: 5px;
  position: absolute;
  top: 100%;
  white-space: pre-line;
  opacity: 0;
  transition: opacity 0.2s ease-in, bottom 0.3s ease-in;
`
